/* eslint quote-props: 0 */
export default {
  'OK': 'ตกลง',
  'Login': 'เข้าสู่ระบบ',
  'Logout': 'ออกจากระบบ',
  'Tenant': 'บริษัท',
  'E-mail': 'อีเมล',
  'Password': 'รหัสผ่าน',
  'Please input a valid email address': 'กรุณากรอกอีเมลให้ถูกต้อง',
  'Please input password': 'กรุณากรอกรหัสผ่าน',
  'Password Repeat': 'ยืนยันรหัสผ่าน',
  'Please input password again': 'กรุณากรอกรหัสผ่านอีกครั้ง',
  'Please input password is not matched': 'กรุณากรอกรหัสผ่านให้เหมือนกัน',
  'Confirm': 'ยืนยัน',
  'Admin Panel': 'ส่วนจัดการดูแลระบบ',
  'Submitting...': 'กำลังส่งข้อมูล...',
  'Loading...': 'กำลังดึงข้อมูล...',
  'Successfully logged out.': 'ออกจากระบบสำเร็จแล้ว',
  'Reset Password': 'เปลี่ยนรหัสผ่าน',
  'Recover Password now!': 'เปลี่ยนรหัสผ่านทันที!',
  'Forgot your password?': 'ลืมรหัสผ่านใช่หรือไม่?',
  'Successfully changed your password.': 'เปลี่ยนรหัสผ่านของคุณสำเร็จแล้ว',
  'The reset password instructions should send to your email shortly.': 'ระบบกำลังจัดส่งอีเมลสำหรับการเปลี่ยนรหัสผ่านไปยังอีเมลของท่าน',
  // Notify Message title
  'Cancel': 'ยกเลิก',
  'Success': 'สำเร็จแล้ว',
  'Submit': 'ส่งข้อมูล',
  'Terminate': 'ลบข้อมูล',
  'Save and continue': 'บันทึกและดำเนินการต่อ',
  'Warning': 'ระวัง',
  // Error Messages
  'Unexpected error': 'เกิดข้อผิดพลาดที่ไม่สามารถระบุได้',
  // Error 401
  '4011': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  // Error 403
  '4031': 'ไม่มีการใช้งานเกิน 30 นาที',
  '4032': 'โทเค็นหมดอายุ',
  // '4033': 'เซสชั่นถูกเปลี่ยนแปลง',
  '4033': 'บัญชีถูกเข้าสู่ระบบจากเซสชั่นอื่นแล้ว',
  '4034': 'ออกจากระบบอยู่แล้ว',
  '4035': 'บัญชีถูกระงับการใช้งาน กรุณาติดต่อผู้ดูแลระบบ',
  '4036': 'โทเค็นไม่ถูกต้อง',
  '4037': 'รหัสผ่านปัจจุบันของคุณถูกใช้งานเป็นเวลามากกว่า 90 วันแล้ว ระบบกำลังทำการส่งอีเมลให้คุณเพื่อทำการตั้งรหัสผ่านใหม่',
  '4038': 'กรุณาตั้งรหัสผ่านใหม่ให้แตกต่างจากรหัสผ่านปัจจุบันของคุณ',
};




// WEBPACK FOOTER //
// ./src/i18n/th.js